import * as React from 'react';
import { Input, InputProps } from 'antd';
import { CustomInputLabel, CustomModifiedMarker } from '..';
import { Utils } from '../../misc';
import './CustomInput.less';

export interface CustomInputProps extends Omit<InputProps, 'placeholder'> {
    label: string;
    labelTooltip?: string;
    required?: boolean;
    topRightNode?: React.ReactNode;
    containerStyle?: React.CSSProperties;
    hasError?: boolean;
    showModifiedMarker?: boolean;
    getContainerRef?: (containerRef: React.RefObject<HTMLDivElement>) => void;
}

const CustomInput: React.FC<CustomInputProps> = (props: CustomInputProps) => {
    const {
        label,
        labelTooltip,
        required,
        topRightNode,
        containerStyle,
        hasError,
        showModifiedMarker,
        getContainerRef,
        ...inputProps
    } = props;

    const containerRef = React.useRef<HTMLDivElement>(null);

    const ref = React.useRef<Input>(null);

    React.useEffect(() => {
        if (getContainerRef) {
            getContainerRef(containerRef);
        }
    }, [getContainerRef]);

    const getContainerClassName = () => {
        let className = 'custom-input-container';

        if (hasError) {
            className += ' has-error';
        }

        return className;
    };

    const getInputClassName = () => {
        let className = 'custom-input';

        if (inputProps.allowClear) {
            className += '-allow-clear';
        }

        if (Utils.hasValue(inputProps.value)) {
            className += ' not-empty';
        }

        return className;
    };

    return (
        <div ref={containerRef} className={getContainerClassName()} style={containerStyle}>
            {!!topRightNode && <div className="top-right-node-container">{topRightNode}</div>}

            <Input className={getInputClassName()} ref={ref} {...inputProps} autoComplete="off" />

            <CustomInputLabel label={label} labelTooltip={labelTooltip} required={required} />

            {showModifiedMarker && <CustomModifiedMarker />}
        </div>
    );
};

export default CustomInput;
